import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ANIMATION_CONTROL_SUBJECT } from '../enums/animation-control.enum';

@Injectable({
  providedIn: 'root',
})
export class AnimationControlService {
  private tableBookingSubject: Subject<boolean> = new Subject<boolean>();
  tableBookingControl$ = this.tableBookingSubject.asObservable();

  updateAnimationControl(subject: ANIMATION_CONTROL_SUBJECT, value: boolean) {
    this[subject].next(value);
  }
}
